import { CREATE_ROOM, JOIN_ROOM, LEAVE_ROOM, roomActionTypes } from './room.types';

export const selectRoomInfo = (state) => state.room.roomInfo;

export const setRoomInfo = (roomInfo) => {
  return {
    type: roomActionTypes.SET_ROOM_INFO,
    payload: roomInfo
  };
};